import React, { useEffect, useState } from "react";
import API from "../api/api";
import "./MostlyUsedLinks.css";

export default function MostlyUsedLinks() {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await API.get("/mostly-used/all");
      setLinks(res.data.data);
    } catch (err) {
      console.error("Error loading links", err);
    }
  };

  return (
    <div className="mostly-used-container">
      <h3 className="mostly-used-title">Mostly Used Links</h3>

      <div className="marquee">
        <div className="marquee-content">
          {links.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="logo-item"
            >
              <img src={item.logo} alt="logo" />
            </a>
          ))}

          {/* Duplicate for infinite effect */}
          {links.map((item, index) => (
            <a
              key={`dup-${index}`}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="logo-item"
            >
              <img src={item.logo} alt="logo" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
